import React from "react"
import { Flash } from "../../app/flash" // The actual Flash component

/* This is the new React component for flash messages
 *
 * IF YOU UPDATE THIS FILE, YOU MUST ALSO UPDATE THE SERVER-SIDE RENDERED COMPONENT IN /app/views/layouts/_messages.html.erb
 * @param {object} flash - The flash messages
 */

export function Messages({ flash }) {
  const validLevels = ["error", "alert", "notice", "success"]

  return (
    <div className="alerts" id="alerts">
      {Object.entries(flash).map(([level, message], index) => {
        if (
          !validLevels.includes(level) ||
          !message ||
          typeof message !== "string"
        ) {
          return null
        }

        return <Flash key={`flash-${index}`} message={message} level={level} />
      })}
    </div>
  )
}
